import { useSetAtom } from 'jotai';
import { editorCJSeancePayloadAtom } from './atom';

export const useOpenUpdateCJSeanceModal = () =>
  useSetAtom(editorCJSeancePayloadAtom);
